import { render, staticRenderFns } from "./wiring.vue?vue&type=template&id=206936ba&scoped=true"
import script from "./wiring.vue?vue&type=script&lang=js"
export * from "./wiring.vue?vue&type=script&lang=js"
import style0 from "./wiring.vue?vue&type=style&index=0&id=206936ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206936ba",
  null
  
)

export default component.exports